import { useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { useAuth } from "../lib/hooks/useAuth";
import { ArrowLeft } from "lucide-react";
import { useViewStore } from "@/lib/stores/view";


export default function LoginForm() {
	const { isLoading } = useAuth();
	const [_, setError] = useState("");
	const { setCurrentView } = useViewStore();

	const handleMicrosoftSSO = async () => {
		setError("");

		try {
			// Dynamically import Microsoft auth service
			const { microsoftAuth } = await import("../lib/services/microsoftAuth");

			// Check if Microsoft SSO is properly configured
			if (!microsoftAuth.isConfigured()) {
				setError("Microsoft SSO chưa được cấu hình. Vui lòng liên hệ quản trị viên.");
				return;
			}

			// Redirect to Microsoft login
			microsoftAuth.redirectToLogin();
		} catch (error) {
			console.error("Microsoft SSO error:", error);
			setError("Không thể kết nối đến dịch vụ Microsoft. Vui lòng thử lại sau.");
		}
	};

	return (
		<div className='min-h-screen flex items-center justify-center bg-muted/50 p-4'>
			<div className="w-full max-w-md">
				<Card className=''>
					<CardHeader className='text-center'>
						<CardTitle className='text-xl'>
							<img src='https://vlmhub.vlu.edu.vn/media/logo/VLU_Logo_Final_VLU_logo%20ngang_Eng.png' alt='' className='w-48 mx-auto' />
						</CardTitle>
						<p className='text-sm text-muted-foreground mt-3'>HỆ THỐNG TRA CỨU</p>
					</CardHeader>
					<CardContent>
						<Button type='button' variant='outline' className='w-full cursor-pointer' onClick={handleMicrosoftSSO} disabled={isLoading}>
							<svg width='800px' height='800px' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='none'>
								<path fill='#F35325' d='M1 1h6.5v6.5H1V1z' />
								<path fill='#81BC06' d='M8.5 1H15v6.5H8.5V1z' />
								<path fill='#05A6F0' d='M1 8.5h6.5V15H1V8.5z' />
								<path fill='#FFBA08' d='M8.5 8.5H15V15H8.5V8.5z' />
							</svg>

							{isLoading ? "Đang xác thực..." : "Đăng nhập bằng Microsoft"}
						</Button>
					</CardContent>
					<CardFooter>
						<div className='text-center text-sm mt-2 w-full'>P.CNTT © 2023</div>
					</CardFooter>
				</Card>
				<div className="text-center">
					<Button variant='link' className='mt-4 p-0' onClick={() => {
						setCurrentView("search");
					}}><ArrowLeft /> <span>Quay về trang tra cứu</span></Button>
				</div>
			</div>
		</div>
	);
}
